/**
 * Created by Daniel Wang on 1/29/2024.
 * Description: Component for store cache to file widget
 * ------ maintenance history ------
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import * as _lodash from 'lodash';
import { of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { StringLiteralsPipe } from '../../../../pipes/translate.pipe';

import { CacheType, StoreCacheToFile } from '../../../../tamalelibs/models/admin-page.model';
import { AdminPagesService } from '../../../../tamalelibs/services/admin-page.service';
import { NotificationStyles } from '../../../../widgets/notification/notification.model';
import { ToastService } from '../../../../widgets/toast/toast.service';

@Component({
    selector: 'tam-store-cache-to-file-widget',
    templateUrl: './store-cache-to-file-widget.component.html',
    styleUrls: ['./store-cache-to-file-widget.component.scss']
})
export class StoreCacheToFileWidgetComponent implements OnInit, OnDestroy {
    @Input() config: StoreCacheToFile;

    // #region public properties
    fileName = new UntypedFormControl('');
    filePath = new UntypedFormControl('');
    title = '';
    // #endregion

    // #region private properties
    // #endregion

    // #region constructor
    constructor(
        private _adminPagesServcie: AdminPagesService,
        private _toast: ToastService,
    ) { }
    // #endregion

    // #region angular functions
    ngOnInit() {
        this.title = this._adminPagesServcie.findKeyByValue(CacheType, this.config.cacheType) + ' Cache';
    }

    ngOnDestroy(): void {
    }
    // #endregion

    // #region public functions
    /** Check the length of name. When the length of the name is valid, dispatches action to the store to create/edit object. */
    onSubmitClick() {
        if (this._isValid()) {
            this._adminPagesServcie.cacheStoreToFile(this.config).pipe(
                take(1),
                catchError(error => {
                    this._toast.notify({
                        style: NotificationStyles.Error,
                        message: error
                    });
                    return of('error');
                })
            ).subscribe(res => {
                if (res && res.message.toUpperCase() === StringLiteralsPipe.translate('general.ok')) {
                    let message = '';
                    const catcheType = this._adminPagesServcie.findKeyByValue(CacheType, this.config.cacheType);
                    message = catcheType + ' cache written to ' + this.config.filePath + '/' + this.config.fileName + ' successfully';
                    this._toast.notify({
                        style: NotificationStyles.Success,
                        message: message
                    });
                }
            });
        }
    }
    // #endregion

    // #region private functions
    private _isValid(): boolean {
        let isValid = true;

        this.fileName.setErrors(null);
        if (!this.fileName.value) {
            this.fileName.setErrors({
                required: true
            });
            isValid = false;
        } else if (this.fileName.value.length > 128) {
            this.fileName.setErrors({
                maxlength: true
            });
            isValid = false;
        }

        this.filePath.setErrors(null);
        if (!this.filePath.value) {
            this.filePath.setErrors({
                required: true
            });
            isValid = false;
        }
        return isValid;
    }
    // #endregion
}
